/**
 * Monday Coffee — FAQ clinique (design 2a).
 * Web Component : un seul volet ouvert à la fois. L'ouverture se fait via la classe
 * .open sur .faqc-item (l'animation grid-template-rows est gérée en CSS).
 * Pas de dépendance : accessibilité par <button> natif + aria-expanded.
 */
class FaqClinique extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
  }

  onClick = (event) => {
    const button = event.target.closest('.faqc-q');
    if (!button || !this.contains(button)) return;

    const item = button.closest('.faqc-item');
    if (!item) return;

    const willOpen = !item.classList.contains('open');

    // Single-open : referme tout volet déjà ouvert.
    this.querySelectorAll('.faqc-item.open').forEach((openItem) => {
      openItem.classList.remove('open');
      const openButton = openItem.querySelector('.faqc-q');
      if (openButton) openButton.setAttribute('aria-expanded', 'false');
    });

    if (willOpen) {
      item.classList.add('open');
      button.setAttribute('aria-expanded', 'true');
    }
  };
}

if (!customElements.get('faq-clinique')) {
  customElements.define('faq-clinique', FaqClinique);
}
